import React from 'react'

import Experiment from '@mc/experiments-react'
import { getNumberOfInstructors } from '@mc/instructors'
import { Trans } from '@mc/i18n'

import { REVAMPED_PRICING_COPY_EXP_FLAG } from './constants'
import { REVAMPED_PRICING_COPY_I18N_NAMESPACE } from './i18n'

type RevampedPricingCopyExpProps = {
  control: () => React.ReactNode
  monetizedYearPricePerMonth: string
  translationKey?: string
}

export const RevampedPricingCopyExp = ({
  control,
  monetizedYearPricePerMonth,
  translationKey = 'long',
}: RevampedPricingCopyExpProps) => {
  const revampedPricingText = () => (
    <Trans
      i18nKey={`revampedPricing.${translationKey}`}
      values={{
        price: monetizedYearPricePerMonth,
        numClasses: getNumberOfInstructors(),
      }}
      ns={REVAMPED_PRICING_COPY_I18N_NAMESPACE}
    />
  )

  return (
    <Experiment
      name={REVAMPED_PRICING_COPY_EXP_FLAG}
      default={control}
      variant_1={revampedPricingText}
    />
  )
}
